import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/tools/almanac/AlmanacContent.tsx");
